import { Component, TemplateRef, ViewChild } from '@angular/core';

import { TwcDrawerComponent } from '@topcon/twc-angular';

import { ExpressionConfig, Operator } from './expression-config';
import { ExpressionEditorService } from './expression-editor.service';

/**
 * Component for displaying the sidebar drawer expression editor.
 */
@Component({
    selector: 'cw-expression-editor',
    templateUrl: './expression-editor.component.html',
    styleUrls: ['./expression-editor.component.scss'],
    standalone: false,
})
export class ExpressionEditorComponent {
    @ViewChild('expressionEditor', { static: false })
    readonly expressionEditor!: TemplateRef<TwcDrawerComponent>;

    get expressionState(): ExpressionConfig {
        return this.expressionEditorService.expressionState;
    }

    constructor(private expressionEditorService: ExpressionEditorService) {}

    /**
     * Get operator tooltip by symbol.
     * @param opSymbol Operator symbol.
     */
    getTip(opSymbol: string): string {
        return this.expressionEditorService.getTip(opSymbol);
    }

    /**
     * Get the input pattern for the current field type.
     */
    getInputPattern(): string {
        return this.expressionEditorService.getInputPattern();
    }

    /**
     * Gets the list of available operators for current field.
     */
    getVisibleOperators(): Operator[] {
        return this.expressionEditorService.getVisibleOperators();
    }

    /**
     * Translates the field name to a string.
     */
    translateByField(field: string): string {
        return this.expressionEditorService.translateByField(field);
    }

    /**
     * Sets the expression string to 'true'.
     */
    setAlwaysTrue(): void {
        this.expressionEditorService.setOutputExpressionString('true');
    }

    /**
     * Sets the expression type to predefined and triggers change.
     */
    setPredefined(): void {
        this.expressionEditorService.setPredefined();
    }

    /**
     * Sets the expression type to custom and triggers change.
     */
    setCustom(): void {
        this.expressionEditorService.setCustom();
    }

    /**
     * Checks if the field expression is of predefined type.
     */
    isPredefined(): boolean {
        return this.expressionEditorService.isPredefined();
    }

    /**
     * Checks if the field expression is of custom type.
     */
    isCustom(): boolean {
        return this.expressionEditorService.isCustom();
    }
}
